// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608030903/js/" + chunkId + "." + {"44":"88d2d02b","225":"7d490f30","481":"ba838dc2","486":"bd82e61b","770":"a784d9a1"}[chunkId] + ".0.8849435499390119.chunk.js";
};